<template>
  <BaseCard>
    <BaseCardBody clear-padding class="overflow-hidden relative">
      <img :src="coverImage" class="aspect-[1/1] object-cover" />
      <a
        :href="post.permalink"
        target="_blank"
        class="absolute inset-0 w-full h-full flex items-center justify-center group hover:bg-black hover:bg-opacity-50 transition-all"
      >
        <span
          class="hidden group-hover:inline-flex text-white border border-white px-6 py-3 hover:bg-white hover:text-black transition-all rounded"
          >VIEW {{ isVideoPost ? 'VIDEO' : 'POST' }}</span
        >
      </a>
    </BaseCardBody>
    <BaseCardBody class="space-y-5">
      <div class="text-gray-600 text-xs">{{ createdAt }}</div>
      <p v-if="hasCaption" class="break-words text-sm">
        {{ caption }}
      </p>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
import moment from 'moment';
import { truncate } from 'lodash-es';

export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  computed: {
    coverImage() {
      if (typeof this.post.thumbnail_url === 'string') {
        return this.post.thumbnail_url;
      }

      if (this.isImagePost || this.isCarouselAlbumPost) {
        return this.post.media_url;
      }

      return '';
    },
    hasCaption() {
      return typeof this.post.caption === 'string';
    },
    caption() {
      return this.hasCaption ? truncate(this.post.caption, { length: 125 }) : '';
    },
    isImagePost() {
      return this.post.media_type === 'IMAGE';
    },
    isCarouselAlbumPost() {
      return this.post.media_type === 'CAROUSEL_ALBUM';
    },
    isVideoPost() {
      return this.post.media_type === 'VIDEO';
    },
    createdAt() {
      return moment.utc(this.post.timestamp).local().format('DD/MM/YYYY HH:mm');
    },
  },
};
</script>
